import { useMemo } from 'react';

import type { ClaimWorkItem } from '../../../store';

import { IssueDetail } from './IssueDetail';
import { buildIssueDetail } from './issueDetailModel';
import { useIssueDetail } from './useIssueDetail';

export interface IssueDetailContainerProps {
  /** The cell's own count phrase. */
  headline: string;
  item: ClaimWorkItem;
}

/**
 * The Issues popover's content: the row now, the certification when it
 * lands. Mount it as `HoverDetail`'s content, which renders only while the
 * popover is open, and the read starts on open.
 */
export const IssueDetailContainer = ({ headline, item }: IssueDetailContainerProps) => {
  const { certification, loading } = useIssueDetail(item.claim_id);
  const model = useMemo(() => buildIssueDetail(item, certification), [certification, item]);
  return <IssueDetail headline={headline} loading={loading} model={model} />;
};
